import { cn } from '@/utils';
import { CloseOutlined } from '@ant-design/icons';
import { memo, useCallback } from 'react';
import { ResizableBox } from 'react-resizable';

import { Popover } from 'antd';

import { TableWithActions } from '../';
import Button from '../common/button';
import { useLogic } from './logic';
import { AssignmentHistoryViewProps } from './type';

const AssignmentHistoryLayerComponent = (props: AssignmentHistoryViewProps) => {
	const { title = '배정 이력' } = props;
	const {
		dataSource,
		columns,
		handleClosePopover,
		state,
		onClick,
		scrollHeight,
		handleResize,
		handleOpenPopover,
	} = useLogic(props);

	const table = useCallback(() => {
		return (
			<div onClick={onClick} className="overflow-y-auto">
				<div className="flex justify-between items-center">
					<p className="text-base font-semibold text-black">{title}</p>
					<div>
						<Button
							icon={<CloseOutlined className="w-4 h-4" />}
							type="text"
							className="min-w-10"
							onClick={handleClosePopover}
						/>
					</div>
				</div>
				<TableWithActions
					actionHidden
					columns={columns}
					dataSource={dataSource}
					rowKey={'id'}
					pagination={false}
					loading={state.loading}
					className="work-history-table"
					containerClassName="p-0"
					scroll={{ y: scrollHeight }}
				/>
			</div>
		);
	}, [columns, state, scrollHeight, title]);

	const contentPopover = useCallback(() => {
		return (
			<div onClick={onClick}>
				<ResizableBox
					width={state.width}
					height={state.height}
					resizeHandles={['sw']}
					minConstraints={[600, 260]}
					maxConstraints={[1500, 800]}
					className="resize-box"
					onResize={handleResize}
				>
					{table()}
				</ResizableBox>
			</div>
		);
	}, [state]);

	return (
		<div className="render-cell">
			<Popover
				placement="bottomRight"
				content={contentPopover}
				prefixCls="work-history"
				trigger={'click'}
				arrow={{
					pointAtCenter: true,
				}}
				open={state.visible}
				onOpenChange={handleOpenPopover}
			>
				<div
					onClick={onClick}
					className={cn(
						'text-blue2 underline cursor-pointer',
						state.visible ? 'font-bold' : ''
					)}
				>
					더보기
				</div>
			</Popover>
		</div>
	);
};

export default memo(AssignmentHistoryLayerComponent);
